import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

class Checkbox extends React.Component {
    render() {
        const { name, label, checked, onChange } = this.props;
        const classes = ['Checkbox', ...this.props.classes];
        return (
            <label className={classes.join(' ')} htmlFor={name}>
                <input
                    type="checkbox"
                    name={name}
                    className="Checkbox__input"
                    id={name}
                    checked={checked}
                    onChange={onChange}
                />
                <div className="Checkbox__icon">
                    <Isvg src="/svg/icon-check-small.svg" className="Checkbox__check" />
                </div>
                <div className="Checkbox__label">{label}</div>
            </label>
        );
    }
}

Checkbox.propTypes = {
    classes: PropTypes.arrayOf(PropTypes.string),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    checked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
};

Checkbox.defaultProps = {
    classes: [],
    label: '',
    checked: false,
};

export default Checkbox;
